import { z } from 'zod';

import type { AssociatedType } from '@/models/AssociatedType.ts';

export const TempNoteStatusSchema = z.enum([
  'PENDING',
  'ACTIVE',
  'COMPLETE',
  'TERMINATED',
]);
export type TempNoteStatus = z.infer<typeof TempNoteStatusSchema>;

export const TempNoteSchema = z.object({
  id: z.string(),
  content: z.string(),
  createUserId: z.string(),
  createUserName: z.string().nullable().optional(),
  createReasonId: z.string(),
  callId: z.string().nullable().optional(),
  bindId: z.string(),
  bindType: z.custom<AssociatedType>().nullable(),
  bindName: z.string().nullable().optional(),
  startDate: z.string().nullable(),
  endDate: z.string().nullable(),
  status: TempNoteStatusSchema.nullable().optional(),
  alarmTest: z.boolean().nullable().optional(),
  alarmType: z.array(z.string()).nullable().optional(),
  completeTime: z.string().nullable(),
  completeUserId: z.string().nullable().optional(),
  completeUserName: z.string().nullable().optional(),
  createDate: z.string().nullable().optional(),
  lastUpdateDate: z.string().nullable().optional(),
});

export type TempNote = z.infer<typeof TempNoteSchema>;
